import type { Locale } from 'date-fns'

import type { LanguageId } from '@mntn-dev/domain-types'

import { fallbackLocale, locales } from '../settings.ts'

export const getLocale = (languageId: string): Locale => {
  return locales[languageId as LanguageId] || fallbackLocale
}
